import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
    isBossPlayAudio: boolean;
    namePlayAudio: string;
}

const initialState: CommonState = {
    isBossPlayAudio: false,
    namePlayAudio: '',
};

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        setIsBossPlayAudio: (state, action: PayloadAction<{ isBossPlayAudio: boolean; namePlayAudio: string }>) => {
            state.isBossPlayAudio = action.payload.isBossPlayAudio;
            state.namePlayAudio = action.payload.namePlayAudio;
        },
        clearIsBossPlayAudio: (state) => {
            state.isBossPlayAudio = false;
            state.namePlayAudio = '';
        },
    },
});

export const { setIsBossPlayAudio, clearIsBossPlayAudio } = commonSlice.actions;

export default commonSlice.reducer;
